import { FlightProviderEnum } from '../flight/enums/enum-flight-provider.model';
import { FlightCabinEnum } from './enumFlightCabin.model';
import { FlightSearchPassengerInput } from './flightSearchPassenger.model';

// The 3 providers actually wired on this endpoint - the backend enum has
// more values (AMADEUS_SMART_CACHE, AMADEUS_INSTANT_SEARCH, PULPO) that
// aren't usable here, so the UI must only ever offer these.
export const FLIGHT_SEARCH_PROVIDERS: FlightProviderEnum[] = [
  FlightProviderEnum.AMADEUS_QUICK_CONNECT,
  FlightProviderEnum.TRAVELPORT_UNIVERSAL_API,
  FlightProviderEnum.DUFFEL,
];

export interface SearchInput {
  providers: FlightProviderEnum[];
  wayDepartureIATA: string;
  wayArrivalIATA: string;
  wayDate: string;
  // Omitted entirely (not sent as empty strings) for a one-way search.
  backDepartureIATA?: string;
  backArrivalIATA?: string;
  backDate?: string;
  passengers: FlightSearchPassengerInput[];
  cabin: FlightCabinEnum;
}
